import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
// theme
import ThemeConfig from "./theme";
// Apps
import App from "./App"

import { store } from './helpers';
import { Provider } from 'react-redux';

import { BrowserRouter } from 'react-router-dom';

import { AppConfigProvider } from './contexts/AppConfigContext';

process.env.NODE_ENV !== "development" && Sentry.init({
  dsn: "https://9ef712d8694443fa9b4c783b228aed94@report.team-x.ir/5",
  integrations: [new BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.2,
});

ReactDOM.render(
  <ThemeConfig>
    <Provider store={store}>
      <BrowserRouter>
        <AppConfigProvider>
          <App />
        </AppConfigProvider>
      </BrowserRouter>
    </Provider >
  </ThemeConfig>,
  document.getElementById('root')
);


